import React from "react";

interface TagProps {
  name: string;
  icon?: React.ReactElement | string;
  className?: string;
}

const Tag: React.FC<TagProps> = ({ name, icon, className = "" }) => {
  const classes =
    `flex items-center bg-gray-800 px-3 py-1 rounded-full text-sm ${className}`.trim();
  return (
    <span className={classes}>
      {icon && (
        <span className="mr-2">
          {typeof icon === "string" ? <img src={icon} alt={name} className="w-4 h-4" /> : icon}
        </span>
      )}
      {name}
    </span>
  );
};

export default Tag;
